<h1>{{isCompare ? locale.compareSymbol : locale.searchSymbol}}</h1>

<div class="dialog" #dialog>
  <form class="form" [formGroup]="form">
    <ng-container *ngIf="cardId !== chartTypeEnum.IV_DIFFERENCE || !isCompare">
      <ng-container *ngTemplateOutlet="autocomplete; context: {control: form.get(filterTypes.STOCK_ID)}"></ng-container>
    </ng-container>

    <ng-container *ngIf="mainSeriesSelectedFilters && cardId !== chartTypeEnum.IV_DIFFERENCE" formGroupName="filters">
      <ng-container *ngFor="let key in filters.controls">
        <ng-container *ngIf="key !== filterTypes.TIME_RANGE">
          <ng-container *ngTemplateOutlet="dropdown; context: {controlName: key}"></ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="cardId === chartTypeEnum.IV_DIFFERENCE && isCompare">
      <div class="controls-frame">
        <h3>{{locale.firstPoint}}</h3>

        <ng-container *ngIf="filters.get(filterTypes.STOCK_ID + '-first')">
          <ng-container *ngTemplateOutlet="autocomplete; context: {control: filters.get(filterTypes.STOCK_ID + '-first')}"></ng-container>
        </ng-container>

        <ng-container *ngIf="filters.get(filterTypes.IVX_TERM + '-first')">
          <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.IVX_TERM + '-first'}"></ng-container>
        </ng-container>

        <ng-container *ngIf="filters.get(filterTypes.MONEYNESS + '-first')">
          <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.MONEYNESS + '-first'}"></ng-container>
        </ng-container>
      </div>

      <div class="controls-frame">
        <h3>{{locale.secondPoint}}</h3>

        <ng-container *ngIf="filters.get(filterTypes.STOCK_ID + '-second')">
          <ng-container *ngTemplateOutlet="autocomplete; context: {control: filters.get(filterTypes.STOCK_ID + '-second')}"></ng-container>
        </ng-container>

        <ng-container *ngIf="filters.get(filterTypes.IVX_TERM + '-second')">
          <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.IVX_TERM + '-second'}"></ng-container>
        </ng-container>

        <ng-container *ngIf="filters.get(filterTypes.MONEYNESS + '-second')">
          <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.MONEYNESS + '-second'}"></ng-container>
        </ng-container>
      </div>
    </ng-container>
  </form>

  <div class="button-container">
    <button
      statistic
      [statisticElementName]="'Apply compare symbol dialog'"
      class="iv-flat-button"
      (click)="submit()"
      [disabled]="form.invalid"
    >
      {{locale.apply}}
    </button>
  </div>

  <div *ngIf="noData" class="no-data">
    {{errorText}}
  </div>
</div>

<ng-template #autocomplete let-control="control">
  <ng-container [formGroup]="form">
    <iv-live-symbols-autocomplete
      class="form__control symbols-autocomplete-overrides"
      [formControl]="control"
      valueExpr="nameAndExchange"
      [container]="isFullScreenOpened ? dialog : undefined"
      [dataSource]="listStocks"
      [showClearButton]="true"
      [placeholder]="locale.searchSymbol"
      (selectedItem)="autocompleteItemClick($event)"
      (valueChanged)="updateFormValidity($event, control)"
    ></iv-live-symbols-autocomplete>
  </ng-container>
</ng-template>

<ng-template #dropdown let-controlName="controlName">
  <ng-container [formGroup]="filters">
    <iv-live-dropdown-new
      class="form__control form__dropdown-selector"
      [class.form__control-disabled]="filters.disabled"
      [templateField]="dropdownTemplateField(controlName)"
      [formControlName]="controlName"
      [label]="getFilterName(controlName)"
      [contentWidth]="true"
      [listValues]="$any(filterPattern[controlName])"
      [isAutocomplete]="getFilterName(controlName) === 'Strike'"
      (onStrikeChanged)="onStrikeChanged($event)"
    ></iv-live-dropdown-new>
  </ng-container>
</ng-template>
